export const LIST_SIZES = ['regular', 'compact', 'small']
export const LIST_TYPES = ['primary', 'secondary']
